import { getMethods as getProjectManagerMethods } from './ProjectManager';

const getController = (service: 'FlowManager') => ({
	ProjectManager: getProjectManagerMethods(service, 'ProjectManager')
});

export { getController };
